import { useQuery } from 'react-query'
import { calculateSubscriptionPrice } from 'services/plan'

/** Real price of `monthCount` months of the subscription package for this fund.
 *  Priced server-side per 50 active members, so it changes with the fund. */
export default function useGetPrice(boxId?: string, monthCount?: number) {
    const { data, isLoading, isError } = useQuery(
        ['subscription-price', boxId, monthCount],
        calculateSubscriptionPrice,
        { enabled: !!boxId && !!monthCount }
    )
    return { price: data?.amount, isLoading, isError }
}
